module.exports = {
      id: "comm-children-usage",
      viewBox: "0 0 237.872 42.449",
      url: "/" + "sprite-80884a0dd6365dbc8eb28b3bec27c8f5.svg#comm-children",
      toString: function () {
        return this.url;
      }
    }